import { gql } from 'apollo-angular';

const APPROVAL_FRAGMENT = gql`
  fragment approvalFields on CommitteeApproval {
    id
    status
    committeeApprovalType {
      id
      name
    }
    milestone_id
    project_id
    user {
      person {
        name
      }
    }
    created
    modified
  }
`;

const CREATE_APPROVAL = gql`
  ${APPROVAL_FRAGMENT}
  mutation createCommitteeApproval($input: CommitteeApprovalInput) {
    approval: createCommitteeApproval(input: $input) {
      ...approvalFields
    }
  }
`;
const UPDATE_APPROVAL = gql`
  ${APPROVAL_FRAGMENT}
  mutation updateCommitteeApproval($input: CommitteeApprovalInput, $id: ID!) {
    approval: updateCommitteeApproval(id: $id, input: $input) {
      ...approvalFields
    }
  }
`;
const REQUEST_APPROVALS = gql`
  ${APPROVAL_FRAGMENT}
  query requestCommitteeApprovals($input: CommitteeApprovalRequestInput) {
    committeeApprovals(input: $input) {
      ...approvalFields
    }
  }
`;
export default {
  CREATE_APPROVAL,
  UPDATE_APPROVAL,
  REQUEST_APPROVALS,
};
